<template>
    <v-card class="elevation-12" color="grey darken-4" dark>

      <v-card-text v-if="success">
        <v-row>
            <v-col class="d-flex justify-center">
                <v-img src="/img/logo.png" contain max-width="240"/>
            </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center">
            Check your mail, and follow instructions
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-else>
        <v-row>
            <v-col class="d-flex justify-center">
                <v-img src="/img/logo.png" contain max-width="240"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-progress-linear
                    v-if="loading"
                    :indeterminate="true"
                    color="accent"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-alert
                    :value="message"
                    type="error"
                    dismissible
                    transition="scale-transition"
                    v-if="message"
                >{{ message }}</v-alert>
            </v-col>
        </v-row>
        <v-form>
            <v-row>
                <v-col>
                    <v-text-field prepend-icon="mdi-lock" v-model="password" label="New password" type="password"></v-text-field>
                    <v-text-field prepend-icon="mdi-lock" v-model="confirm" label="Confirm your password" type="password"></v-text-field>
                </v-col>
            </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="!success">
        <v-btn outlined to="/login">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn outlined color="accent" v-on:click="doReset()" type="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </template>
  <script>
  import { mapActions, mapGetters } from 'vuex';
  export default {
    components: {},
    data: () => ({
      password: null,
      email: null,
      confirm: null,
      token: null,
      message:null
    }),
    computed: {
    ...mapGetters('auth', ['loading'])
    },
    mounted () {
      this.token = this.$route.query['token']
      this.email = this.$route.query['email']
    },
    methods: {
    ...mapActions('auth', ['resetPassword']),
      doReset() {
        this.message = null
        if(this.password === this.confirm) {
          this.resetPassword({ token: this.token, password: this.password, email:this.email, password_confirmation:this.confirm })
          .then(() => this.success = true)
        }else{
          this.message= "Your confirmation password doesn't match your password"
        }

      }
    }
  };
  </script>
  
  <style></style>
  